import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import Navbar from "../components/Navbar";
import { Link } from "react-router-dom";
import "./Login.css";

export default function Login() {
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isMounted, setIsMounted] = useState(false);
  const navigate = useNavigate();
  const { user, loading, signInWithGoogle, signInWithFacebook } = useAuth();

  useEffect(() => {
    setIsMounted(true);
    const checkTerms = localStorage.getItem("acceptTerms");

    if (checkTerms) {
      setIsChecked(checkTerms === "true");
    }
  }, []);

  useEffect(() => {
    if (loading || !isMounted) return;

    if (user) {
      localStorage.setItem("token", "logged");

      const checkTerms = localStorage.getItem("acceptTerms");
      const logged = localStorage.getItem("login");

      if (checkTerms === "true" && logged === "true") {
        navigate("/select-champion");
      }
    }
  }, [user, loading, navigate, isMounted]);

  const handleGoogleLogin = async () => {
    if (!isChecked) {
      setError(
        "Devi accettare i termini e condizioni di servizio prima di accedere"
      );
      return;
    }
    try {
      await signInWithGoogle();
      localStorage.setItem("login", "true");
      localStorage.setItem("acceptTerms", "true");
    } catch (err: any) {
      console.error("Errore durante il login con Google:", err);
      setError("Errore durante il login con Google");
    }
  };

  const handleFacebookLogin = async () => {
    if (!isChecked) {
      setError(
        "Devi accettare i termini e condizioni di servizio prima di accedere"
      );
      return;
    }
    try {
      await signInWithFacebook();
      localStorage.setItem("login", "true");
      localStorage.setItem("acceptTerms", "true");
    } catch (err: any) {
      console.error("Errore durante il login con Facebook:", err);
      setError("Errore durante il login con Facebook");
    }
  };

  const handleCheckTerms = (checked: boolean) => {
    setIsChecked(checked);
    setError(null);
    localStorage.setItem("acceptTerms", checked.toString());
  };

  return (
    <div className="login-container">
      <Navbar />

      <div className="title color-gradient">
        <h2>Accedi</h2>
      </div>

      <div className="login-button">
        <button className="social" onClick={handleGoogleLogin}>
          <img
            src="/assets/google.png"
            alt="login-google"
            width={16}
            height={16}
          />
          <p>Continua con Google</p>
        </button>

        <button className="social" onClick={handleFacebookLogin}>
          <img
            src="/assets/facebook.png"
            alt="login-facebook"
            width={16}
            height={16}
          />
          <p>Continua con Facebook</p>
        </button>
      </div>

      <div
        className="accept-terms"
        style={{
          width: "100%",
          justifyContent: "center",
        }}
      >
        <div className="allign">
          <input
            type="checkbox"
            name="terms"
            id="terms"
            checked={isChecked}
            onChange={(e) => handleCheckTerms(e.target.checked)}
          />
          <p>
            Accetto i{" "}
            <Link to="/termini">termini e condizioni di servizio</Link>
          </p>
        </div>
      </div>

      {error && <p className="error">{error}</p>}
    </div>
  );
}
